import { Redirect, Route } from 'react-router-dom'
import RouteWrapper, { IRouteWrapperProps } from './Route'
import { useFeatureFlag } from '../hooks/use-feature-flag'
import { TFeatureFlags } from '../store/modules/posthog/types'
import Maintenance from '../pages/Maintenance'

interface IProps extends IRouteWrapperProps {
  featureFlag: TFeatureFlags
  featureFlagCombined?: TFeatureFlags
}

const FeatureFlagRoute = (props: IProps) => {
  const { isEnabled, loading, payload } = useFeatureFlag(props.featureFlag)

  if (loading) {
    return <Route {...props} component={null} />
  }

  if (payload?.maintenance) {
    return (
      <RouteWrapper {...props} component={() => <Maintenance featureFlag={props.featureFlag} />} />
    )
  }

  if (isEnabled === false) {
    return <Redirect to="/home" />
  }

  return <RouteWrapper {...props} />
}

const FeatureFlagCombinedRoute = (props: IProps) => {
  const { isEnabled, loading } = useFeatureFlag(props.featureFlag)
  const combined = useFeatureFlag(props.featureFlagCombined)

  if (loading || combined.loading) {
    return <Route {...props} component={null} />
  }

  if (isEnabled === false || combined.isEnabled === true) {
    return <Redirect to="/home" />
  }

  return <RouteWrapper {...props} />
}

export { FeatureFlagRoute, FeatureFlagCombinedRoute }
